/* =============================================
   BONITA BLOMSTER — Theme JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // ---- Search Drawer ----
  const searchToggle  = document.getElementById('search-toggle');
  const searchDrawer  = document.getElementById('search-drawer');
  const searchClose   = document.getElementById('search-close');
  const searchOverlay = document.getElementById('search-overlay');
  const searchInput   = document.getElementById('search-input');

  function openSearch() {
    searchDrawer.classList.add('is-open');
    searchOverlay.classList.add('is-visible');
    searchDrawer.removeAttribute('aria-hidden');
    setTimeout(() => searchInput && searchInput.focus(), 100);
  }
  function closeSearch() {
    searchDrawer.classList.remove('is-open');
    searchOverlay.classList.remove('is-visible');
    searchDrawer.setAttribute('aria-hidden', 'true');
  }

  if (searchToggle)  searchToggle.addEventListener('click', openSearch);
  if (searchClose)   searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

  // ---- Mobile Nav ----
  const mobileToggle  = document.getElementById('mobile-menu-toggle');
  const mobileNav     = document.getElementById('mobile-nav');
  const mobileClose   = document.getElementById('mobile-nav-close');
  const mobileOverlay = document.getElementById('mobile-nav-overlay');

  function openMobileNav() {
    mobileNav.classList.add('is-open');
    mobileOverlay.classList.add('is-visible');
    mobileToggle.setAttribute('aria-expanded', 'true');
    mobileNav.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileNav.classList.remove('is-open');
    mobileOverlay.classList.remove('is-visible');
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (mobileToggle)  mobileToggle.addEventListener('click', openMobileNav);
  if (mobileClose)   mobileClose.addEventListener('click', closeMobileNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);

  // Mobile accordion submenus — only one open at a time
  document.querySelectorAll('.mobile-nav__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const sub = btn.nextElementSibling;
      if (!sub) return;
      const isOpen = sub.classList.contains('is-open');
      document.querySelectorAll('.mobile-nav__sub.is-open').forEach(el => el.classList.remove('is-open'));
      document.querySelectorAll('.mobile-nav__toggle').forEach(b => b.setAttribute('aria-expanded', 'false'));
      if (!isOpen) {
        sub.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Grandchildren toggles — mobile (.mobile-nav__subtoggle) and desktop (.site-nav__subtoggle)
  document.querySelectorAll('.mobile-nav__subtoggle, .site-nav__subtoggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const sub = btn.closest('li').querySelector('.mobile-nav__subsub, .site-nav__dropdown-sub');
      if (!sub) return;
      const isOpen = sub.classList.contains('is-open');
      sub.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      btn.blur();
    });
  });

  // ---- Keyboard: close drawers on Escape ----
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobileNav();
    }
  });

  // ---- Desktop dropdowns — only one open at a time ----
  function closeAllDropdowns() {
    document.querySelectorAll('.site-nav__link--dropdown').forEach(b => b.setAttribute('aria-expanded', 'false'));
    document.querySelectorAll('.site-nav__dropdown-sub.is-open').forEach(el => el.classList.remove('is-open'));
    document.querySelectorAll('.site-nav__subtoggle').forEach(b => b.setAttribute('aria-expanded', 'false'));
  }

  document.querySelectorAll('.site-nav__link--dropdown').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns();
      if (!expanded) btn.setAttribute('aria-expanded', 'true');
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.site-nav__item--has-dropdown')) {
      closeAllDropdowns();
    }
  });

});
